import React from 'react';
import PropTypes from 'prop-types';
import PoorText from 'components/poor-text';

const ReferencesBlock = ({ heading, column1, column2 }) => {
  return column1 || column2 ? (
    <div className="references-block">
      <div className="references-block__container">
        {heading && (
          <strong className="references-block__heading">{heading}</strong>
        )}
        <div className="references-block__columns">
          {column1 && (
            <PoorText
              text={column1}
              className="references-block__column poor-text_in-references-block"
            />
          )}
          {column2 && (
            <PoorText
              text={column2}
              className="references-block__column poor-text_in-references-block"
            />
          )}
        </div>
      </div>
    </div>
  ) : null;
};

ReferencesBlock.propTypes = {
  heading: PropTypes.string,
  column1: PropTypes.string,
  column2: PropTypes.string,
};

export default ReferencesBlock;
